import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';

function isInViewport(el) {
	const rect = el?.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) +
				el.clientHeight &&
		rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
}
function processLazy() {
	let lazyl = document.querySelectorAll('.lazyl');

	lazyl.forEach((ele, itx) => {
		//console.log(ele, 'lazy on grid');
		if (isInViewport(ele)) {
			ele.setAttribute('data-visible', true);
			if (
				!ele.dataset.loaded ||
				!ele.style.backgroundImage.includes(ele.dataset.image)
			) {
				ele.style.backgroundImage = "url('" + ele.dataset.image + "')";
				ele.setAttribute('data-loaded', true);
			}
		}
	});
}

function addLazy() {
	processLazy();
}

document.addEventListener('DOMContentLoaded', function () {
	window.addEventListener('scroll', addLazy);
});

export default function GLIFOSCollectionGridViewer(props) {
	const { apiService, mySelectedPhotos, galleryRef, hasHierarchyTree } =
		props;

	useEffect(() => {
		processLazy();
	});

	useEffect(() => {
		const element = galleryRef.current;
		element.addEventListener('scroll', addLazy);
		return () => {
			element.removeEventListener('scroll', addLazy);
		};
	}, [galleryRef]);

	return (
		<div className='ggridv'>
			<Container className='p-0 m-0'>
				<Row>
					{mySelectedPhotos.payload.collections?.map((xph, xi) => {
						//console.log(xph, 'xph');
						const isUDS = xph?.level.trim() === 'item';
						const hasDecendents =
							+xph.decendents > 0 || +xph.visibleDecendents > 0;
						const changeNavParam = hasDecendents; // || !isUDS;
						let thisURL = changeNavParam
							? `?nav=${xph.id}`
							: `${process.env.PUBLIC_URL}/item/${xph.id}`;
						const thumbnail = xph?.thumbnail.trim();
						const isImageNull = ['', 'null', 'NULL'].includes(
							thumbnail
						);
						const isadg_area = xph?.id
							.trim()
							.startsWith('GT-CIRMA-FG')
							? 'GT-CIRMA-FG'
							: 'GT-CIRMA-AH';
						const imgURL = !isImageNull
							? xph?.thumbnail
							: apiService.__getDefaultThumbSrc(isadg_area);
						return (
							<Col lg={hasHierarchyTree ? 4 : 3} key={xi}>
								<Link to={thisURL}>
									<Card className='cisadgccrd'>
										<div className='imCard'>
											{(!isImageNull ||
												isadg_area === 'GT-CIRMA-FG' ||
												isUDS) && (
												<div
													className={
														'ci-crd-imgc lazyl' +
														(!isImageNull
															? ''
															: ' default')
													}
													data-image={imgURL}
												></div>
											)}
											{isadg_area === 'GT-CIRMA-AH' &&
												isImageNull &&
												!isUDS && (
													<div
														className={
															'ci-crd-imgc lazyl d-flex justify-content-center align-items-center flex-wrap text-black text-center flex-column' +
															(!isImageNull
																? ''
																: ' default')
														}
													>
														<span>{xph.title}</span>
													</div>
												)}
										</div>
										<Card.Body>
											<Card.Title>
												<div className='isadgid'>
													{xph.id}
												</div>
												{/* {xph.title?.length > 70
													? xph.title.substr(0, 70) +
													  '...'
													: xph.title} */}
												<span className='title-collection'>
													{xph.title}
												</span>
											</Card.Title>
										</Card.Body>
									</Card>
								</Link>
							</Col>
						);
					})}
				</Row>
			</Container>
		</div>
	);
}
